<template>
  <div class="theme-editor z-10 h-full">
    <div class="bg-gray h-8 flex just rounded-t-lg"/>

    <json-input v-if="json"
                v-model="json"
                height="calc(100vh - 20rem)"
                :mode="JSON_EDITOR_MODE.FORM"
                @update:json-validity="$emit('update:json-validity', $event)"
    />
  </div>
</template>

<script>
import JsonInput from '@/components/base-components/JsonInput.vue'
import { JSON_EDITOR_MODE } from '@/constants/json-editor.constants'

export default {
  name: 'SettingsBotThemeJson',

  components: { JsonInput },

  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['input', 'update:json-validity'],

  data() {
    return {
      JSON_EDITOR_MODE
    }
  },

  computed: {
    json: {
      get() {
        return this.value.themeConfig
      },
      set(themeConfig) {
        this.$emit('input', { themeConfig })
      }
    }
  }
}
</script>

<style lang="scss">
.theme-editor {
  div.jsoneditor-tree {
    @apply bg-background;
  }

  div.jsoneditor.jsoneditor-mode-form {
    @apply pt-4 pb-4 pl-4 border-none bg-background overflow-auto #{!important};
  }
}
</style>
